module.exports = __webpack_public_path__ + "img/5.0d9759c7.png";